import React from 'react';
import { Link } from 'react-router-dom';
import deafcantalkLogo from '../assets/deafcantalk_logo.jpeg';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="w-full mt-20 relative overflow-hidden" style={{
      background: 'linear-gradient(135deg, #0D5364 0%, #1E88A8 100%)',
    }}>
      {/* Decorative background circles */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white opacity-5 rounded-full -translate-x-32 -translate-y-32"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white opacity-5 rounded-full translate-x-48 translate-y-48"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16 relative z-10">
        {/* Main footer content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">

          {/* About section */}
          <div className="flex flex-col gap-4 animate-fade-in">
            <div className="flex flex-row items-center gap-3 ">
              <img src={deafcantalkLogo} alt="DeafCanTalk" className="h-8 w-8 sm:h-10 sm:w-10 object-cover rounded-full shadow-md animate-float" />
              <h3 className="text-2xl sm:text-3xl font-bold text-white">DeafCanTalk</h3>
            </div>
            <p className="text-gray-200 text-sm sm:text-base leading-relaxed">
              Empowering the deaf and hard-of-hearing community through innovative technology and inclusive learning.
            </p>
            <div className="flex flex-wrap gap-3 mt-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-white bg-opacity-20 flex items-center justify-center hover:bg-opacity-30 transition-all duration-300 hover-scale"
              >
                <svg width="16" height="16" className="sm:w-5 sm:h-5" fill="white" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-white bg-opacity-20 flex items-center justify-center hover:bg-opacity-30 transition-all duration-300 hover-scale"
              >
                <svg width="16" height="16" className="sm:w-5 sm:h-5" fill="white" viewBox="0 0 24 24">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/deafcantalk/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-white bg-opacity-20 flex items-center justify-center hover:bg-opacity-30 transition-all duration-300 hover-scale"
              >
                <svg width="16" height="16" className="sm:w-5 sm:h-5" fill="white" viewBox="0 0 24 24">
                  <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/deafcantalk/"  
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-white bg-opacity-20 flex items-center justify-center hover:bg-opacity-30 transition-all duration-300 hover-scale"
              >
                <svg width="16" height="16" className="sm:w-5 sm:h-5" fill="white" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div className="flex flex-col gap-4 animate-fade-in delay-100">
            <h4 className="text-lg sm:text-xl font-bold text-white mb-2">Quick Links</h4>
            <Link to="/" onClick={scrollToTop} className="text-gray-200 hover:text-white hover:translate-x-2 transition-all duration-300 no-underline text-sm sm:text-base">
               Home
            </Link>
            <Link to="/about" onClick={scrollToTop} className="text-gray-200 hover:text-white hover:translate-x-2 transition-all duration-300 no-underline text-sm sm:text-base">
               About Us
            </Link>
            <Link to="/education" onClick={scrollToTop} className="text-gray-200 hover:text-white hover:translate-x-2 transition-all duration-300 no-underline text-sm sm:text-base">
               Education
            </Link>
            <Link to="/blog" onClick={scrollToTop} className="text-gray-200 hover:text-white hover:translate-x-2 transition-all duration-300 no-underline text-sm sm:text-base">
               Blog
            </Link>
            <Link to="/gallery" onClick={scrollToTop} className="text-gray-200 hover:text-white hover:translate-x-2 transition-all duration-300 no-underline text-sm sm:text-base">
               Gallery
            </Link>
            <Link to="/contact" onClick={scrollToTop} className="text-gray-200 hover:text-white hover:translate-x-2 transition-all duration-300 no-underline text-sm sm:text-base">
               Contact
            </Link>
          </div>

          {/* Contact info */}
          <div className="flex flex-col gap-4 animate-fade-in delay-200">
            <h4 className="text-lg sm:text-xl font-bold text-white mb-2">Get In Touch</h4>
            <div className="flex items-center gap-3 text-gray-200 hover:text-white transition-colors">
              <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
              </svg>
              <a href="mailto:contact@deafcantalk.com" className="no-underline text-gray-200 hover:text-white text-sm sm:text-base">
                contact@deafcantalk.com
              </a>
            </div>
            <div className="flex items-center gap-3 text-gray-200 hover:text-white transition-colors">
              <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
              </svg>
              <a href="tel:+233533634102" className="no-underline text-gray-200 hover:text-white text-sm sm:text-base">
                +233 53 363 4102
              </a>
            </div>
            <div className="flex items-start gap-3 text-gray-200">
              <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24" className="mt-1">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
              </svg>
              <span className="text-sm sm:text-base">Accra, Ghana</span>
            </div>
          </div>

          {/* Newsletter */}
          <div className="flex flex-col gap-4 animate-fade-in delay-300">
            <h4 className="text-lg sm:text-xl font-bold text-white mb-2">Stay Updated</h4>
            <p className="text-gray-200 text-xs sm:text-sm">Subscribe to our newsletter for the latest updates and resources.</p>
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full px-4 py-3 rounded-lg bg-white bg-opacity-20 border border-white border-opacity-30 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 transition-all"
              />
              <button className="w-full sm:w-auto px-6 py-3 rounded-lg font-semibold text-white bg-white bg-opacity-20 hover:bg-opacity-30 transition-all duration-300 hover-lift">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white border-opacity-20 pt-6 sm:pt-8 mt-6 sm:mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-200 text-xs sm:text-sm text-center md:text-left">
              © 2025 DeafCanTalk. All rights reserved. Made with ❤️ for the deaf community.
            </p>
            <div className="flex flex-wrap gap-4 sm:gap-6 text-xs sm:text-sm justify-center md:justify-end">
              <button className="text-gray-200 hover:text-white transition-colors bg-transparent border-none cursor-pointer text-xs sm:text-sm">
                Privacy Policy
              </button>
              <button className="text-gray-200 hover:text-white transition-colors bg-transparent border-none cursor-pointer text-xs sm:text-sm">
                Terms of Service
              </button>
              <button className="text-gray-200 hover:text-white transition-colors bg-transparent border-none cursor-pointer text-xs sm:text-sm">
                Accessibility
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
